import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CommonDialogService } from '@core/common-dialog/common-dialog.service';
import { TranslationService } from '@core/services/translation.service';
import { BaseComponent } from 'src/app/base.component';
import { AddEditNewsDialogComponent } from './add-edit-news-dialog/add-edit-news-dialog.component';
import { ToastrService } from 'ngx-toastr';
import {
  NewsResponseDto,
  GetNewsListRequestDto,
  NewsRequestDto,
} from '../category-grp/grp.model';
import { GrpserviceService } from '../grpservice.service';

@Component({
  selector: 'app-news-grp',
  templateUrl: './news-grp.component.html',
  styleUrls: ['./news-grp.component.scss'],
})
export class NewsGrpComponent extends BaseComponent implements OnInit {
  displayedColumns: string[] = [
    'action',
    'newsTitle',
    'newsDesc',
    'newsDetails',
    'createdBy',
    'createdDate',
    'updatedBy',
    'updatedDate',
    'approvedBy',
    'approvedDate',
    'approvedStatus',
    'dateActual',
  ];

  dataSource = new MatTableDataSource<NewsResponseDto>([]);
  totalCount = 0;
  pageSize = 10;
  loading = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private commonDialogService: CommonDialogService,
    private toastrService: ToastrService,
    private newsService: GrpserviceService,
    public translationService: TranslationService
  ) {
    super(translationService);
    this.getLangDir();
  }

  ngOnInit(): void {
    this.getNewsList(1, this.pageSize);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  // Updated component method to pass request object to service
  getNewsList(pageNumber: number, pageSize: number): void {
    this.loading = true;
    const request: GetNewsListRequestDto = {
      pageNumber,
      pageSize,
      searchText: '', // You can add a search input later if needed
    };

    this.newsService.getNewsList(request).subscribe({
      next: (res: any) => {
        // Update to match your API response structure
        this.dataSource.data = res.data?.items || [];
        this.totalCount = res.data?.totalRecords || 0;
        this.loading = false;
      },
      error: () => {
        this.toastrService.error('Failed to load news.');
        this.loading = false;
      },
    });
  }

  // ✅ Paginator Event
  onPageChange(event: any): void {
    this.getNewsList(event.pageIndex + 1, event.pageSize);
  }

  openAddEditDialog(news?: NewsResponseDto): void {
    const dialogRef = this.dialog.open(AddEditNewsDialogComponent, {
      width: '600px',
      direction: this.langDir,
      data: { news },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getNewsList(this.paginator.pageIndex + 1, this.paginator.pageSize);
      }
    });
  }

  deleteNews(news: NewsResponseDto): void {
    this.commonDialogService
      .deleteConformationDialog(
        `Are you sure you want to delete "${news.newsTitle}"?`
      )
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          const payload: NewsRequestDto = {
            id: news.id,
            newsTitle: news.newsTitle,
            newsDesc: news.newsDesc,
            newsDetails: news.newsDetails,
            createdBy: null,
            updatedBy: null,
            dateActual: news.dateActual,
            approvedBy: null,
            approvedDate: null,
            approvedStatus: null,
            action: 'DELETE',
          };

          this.newsService.saveNews(payload).subscribe({
            next: () => {
              this.toastrService.success('News deleted successfully.');
              this.getNewsList(
                this.paginator.pageIndex + 1,
                this.paginator.pageSize
              );
            },
            error: () => {
              this.toastrService.error('Failed to delete news.');
            },
          });
        }
      });
  }
}
